import { stockCompanyCreate } from '../../../../../redux/actions/action-creator';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import FormData from 'form-data';
import MasterCreationFooter from '../../../../../components/Footer/Master_Footer/MasterCreationFooter';
import Form from '../../../../../components/Form/Form';
import { prepareFormData, useFormHandler } from '../../../../../components/Custom_Hooks/useFormHandler';
import useClickOutside from '../../../../../components/Custom_Hooks/useClickOutsSide';
import { useInputAction } from '../../../../../components/Custom_Hooks/useInputAction';
import InputField from '../../../../../components/Input/InputField';

function StockCompany({ title, closeModal_sec }) {
    const dispatch = useDispatch();
    const [nameInput, setNameInput] = useState(null)
    const { userData = null } = useSelector(state => state.auth);

    const initialState = {
        name: '',
        alias_name: '',
        company_id: userData?.id
    }
    const [data, setData] = useState(initialState);

    const inputRefs = {
        name: useRef(null),
        alias_name: useRef(null),
    };

    function getCurrentInputRef(name) {
        return inputRefs[name] || null;
    }

    const inputFields = [
        { label: 'Name', name: 'name', type: 'text', isRequired: true, },
        { label: '(alise)', name: 'alias_name', type: 'text', isRequired: false, },
    ];

    const validations = {
        name: (value) => value.trim() !== "",
        alias_name: (value) => value.trim() !== "",
    };


    const refs = Object.keys(inputRefs).reduce((acc, name) => {
        acc[name] = {
            onFocus: () => {
                const ref = getCurrentInputRef(name);
                if (ref) {
                    setNameInput(ref)
                    ref?.current?.setSelectionRange(0, ref?.current?.value?.length)
                };
            },
            onBlur: (value) => {
                if (name === 'name') {
                    if (!value.trim() && submitConfirmRef.current !== 'Quit') {
                        getCurrentInputRef(name)?.current?.focus();
                    }
                }
            },
        };
        return acc;
    }, {});

    const validateForm = () => {
        const requiredFields = [
            { field: 'name', message: 'Required Name Field' },
        ]

        for (let { field, message } of requiredFields) {
            if (!data?.[field]) {
                toast.error(message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSubmitConfirm('');
                getCurrentInputRef(field)?.current?.focus();
                return false;
            }
        }
        return true;
    };

    // Function to reset form fields-----------------------------------------
    const resetForm = () => {
        setData(initialState)
    };

    const { handleChange, handleFocus, handleBlur, handleKeyDown, setSubmitConfirm, submitConfirm, } = useInputAction({
        data,
        setData,
        validations,
        refs,
        check_dropdown: false,
        inputRefs,
    });

    const submitConfirmRef = useRef(submitConfirm);
    useEffect(() => {
        submitConfirmRef.current = submitConfirm;
    }, [submitConfirm]);

    const { handleSubmit, loading, handleFocusReset } = useFormHandler({
        validateForm,
        prepareFormData: () => prepareFormData(data),
        submitForm: (data) => dispatch(stockCompanyCreate(data)),
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => handleSubmit(new Event('submit')),
            },
        ],
        resetForm,
        first_ref: inputRefs?.name,
        closeModal: closeModal_sec,
        setSubmitConfirm,
        submitConfirm
    });

    useEffect(() => {
        handleFocusReset();
    }, []);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Escape') {
                if (submitConfirmRef.current) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    handleFocusReset();
                    return;
                }
                event.preventDefault();
                event.stopImmediatePropagation();
                submitConfirmRef.current = 'Quit';
                setSubmitConfirm('Quit');
                document.activeElement?.blur();
            }
        };
        window.addEventListener('keydown', handleKeyPress, true);
        return () => {
            window.removeEventListener('keydown', handleKeyPress, true);
        };
    }, [dispatch, inputRefs, setSubmitConfirm]);


    const handleClickOutside = (event) => {
        if (nameInput.current) {
            event.preventDefault();
            nameInput.current.focus();
        }
    };

    const handleClickInside = (event) => {
        let clickedElement = event.target;
        if (clickedElement?.tagName &&
            (clickedElement?.tagName.toLowerCase() === 'input' ||
                clickedElement?.tagName.toLowerCase() === 'textarea')) {
            clickedElement.focus();
        }
    };

    useClickOutside(nameInput, handleClickOutside, handleClickInside);


    return (
        <Form
            handleSubmit={handleSubmit}
            handleKeyDown={handleKeyDown}
            submitConfirm={submitConfirm}
            handleFocusReset={handleFocusReset}
            title={title || 'Stock Company Creation'}
            loading={loading}
            col='col-5'
            Footer={MasterCreationFooter}
        >
            <div className='row p-0 ps-2 m-0 mb-1'>
                {inputFields?.map(({ label, name, type, value, ref, isRequired }, index) => (
                    <InputField
                        key={index}
                        lable={label}
                        type={type}
                        name={name}
                        value={data[name]}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        handleFocus={handleFocus}
                        isRequired={isRequired}
                        ref={inputRefs[name]}
                    />
                ))}
            </div>
        </Form>
    )
}

export default StockCompany;
